module.exports = __webpack_public_path__ + "static/media/dumy_project.11ca0b81.jpg";